import React, { useState } from "react";

import { Link, NavLink } from "react-router-dom";
import "./Header.css";
import logo from "../../assets/Images/footer-logo.png";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <header className="simple-header">
      <div className="header-wrapper">
        {/* Logo */}
        <div className="logo-area">
          <Link to="/">
            <img src={logo} alt="Logo" className="simple-logo" />
            <span className="brand-name"></span>
          </Link>
        </div>

        {/* Burger Icon */}
        <div className="burger" onClick={toggleMenu}>
          <div className={`bar ${menuOpen ? "open" : ""}`}></div>
          <div className={`bar ${menuOpen ? "open" : ""}`}></div>
          <div className={`bar ${menuOpen ? "open" : ""}`}></div>
        </div>

        {/* Navigation */}
        <nav className={`nav-links ${menuOpen ? "mobile-open" : ""}`}>
          <NavLink to="/" onClick={closeMenu} className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>Home</NavLink>
          <NavLink to="/about" onClick={closeMenu} className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>About</NavLink>
          <NavLink to="/SourcingServices" onClick={closeMenu} className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>Services</NavLink>
          <NavLink to="/FaqSection" onClick={closeMenu} className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>FAQs</NavLink>
        </nav>

        {/* CTA Button */}
        <div className="cta-button-container">
          <NavLink to="/Contact" onClick={closeMenu} className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}><button className="register-button">Contact</button></NavLink>

          
          {/* <ScrollLink to="/Contact" smooth duration={500}>
            <button className="register-button">Contact</button>
          </ScrollLink> */}
        </div>
      </div>
    </header>
  );
};

export default Header;
